import * as React from 'react'
import { CommonPlaybackAction, PlaybackBlock } from './Headline/PlaybackBlock'
import { DVString } from '@utils'
import { Offers } from './Headline/Offers'
import * as cn from 'classnames'
import * as styles from './Headline.module.scss'

interface HeadlineProps {
    title?: string
    playbackAction: CommonPlaybackAction
    offers?: DVString[]
}

interface HeadlineState extends HeadlineProps {
    transitionStyle?: string
}

export const HeadlineInstance = (props: HeadlineProps) => {
    if (props.playbackAction && props.playbackAction.titleID)
        return (<PlaybackBlock
            playbackAction={{
                ...props.playbackAction,
                label: props.playbackAction.label || props.title
            }} />)
    return <Offers offers={props.offers} />
}

export class Headline extends React.PureComponent<HeadlineProps, HeadlineState> {
    constructor(props: HeadlineProps) {
        super(props)
    }

    shouldTransition(oldProps: HeadlineProps): Boolean {
        const playbackStateChanged = Boolean(oldProps.playbackAction) != Boolean(this.props.playbackAction)
        const playbackLabelChanged = (oldProps.playbackAction && oldProps.playbackAction.label) != (this.props.playbackAction && this.props.playbackAction.label)
        const progressBarChanged = (oldProps.playbackAction && oldProps.playbackAction.resumeTime) != (this.props.playbackAction && this.props.playbackAction.resumeTime)
        return playbackStateChanged || playbackLabelChanged || progressBarChanged
    }

    componentDidUpdate(oldProps: HeadlineProps) {
        // Don't do any side effect if only the state changed
        if (this.shouldTransition(oldProps)) {
            const transitionTimer = 200
            this.setState({ ...oldProps, transitionStyle: styles.old })
            // When fade out finished, swap to fade in new content
            window.setTimeout(() => {
                this.setState({ transitionStyle: styles.new })
                // Cleanup DOM on completion
                window.setTimeout(() =>
                    this.setState({ transitionStyle: null }), transitionTimer)
            }, transitionTimer)
        }
    }

    render() {
        if (this.state && this.state.transitionStyle) {
            const props = this.state.transitionStyle == styles.old ? this.state : this.props
            return (<div className={cn(styles.transitionWrapper, this.state.transitionStyle)}>
                <HeadlineInstance {...props} />
            </div>)
        }
        return <HeadlineInstance {...this.props} />
    }
}